import type { ProductBase } from '~/types/shop'

export enum ItemType {
  NORMAL = 'N',
  KIT = 'Kit',
}

export interface LineItem extends ProductBase {
  productId: string
  quantity: number
  name: string
  originalPrice: number
  qtyLimit: number
  itemType: ItemType
  isPromotionalPricing: boolean
  subTotal: number
  status: string
  lifeCycleState: string
  formattedSubTotal: string
  formattedOriginalPrice: string
  language: string
}

export enum ExclusiveTo {
  SUBSCRIPTION = 'subscription',
  PREPAID = 'prepaid',
  REFILL = 'refill',
  LIMITED_ACCESS = 'selectdemo'
}

export enum ExcludeFrom {
  IDA = 'ida',
  SEARCH = 'search'
}

// These are uppercase in the API
export enum LifeCycleState {
  PREORDER = 'PRE-ORDER',
  LIMITEDACCESS = 'LIMITED ACCESS',
  RETIRING = 'RETIRING',
  LASTCHANCE = 'LAST CHANCE',
  DISCONTINUED = 'DISCONTINUED'
}
